import styled from "styled-components";

import { StyledNavBar } from "../Navbar/Navbar.styles";

export const NoAccessStyledNavbar = styled(StyledNavBar)`
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1), 0px 2px 5px rgba(0, 0, 0, 0.1);
`;
